// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".styles_title__nmwqs {\n  font-size: 1rem !important;\n  font-weight: bold !important;\n}\n\n.styles_button__Vknkk {\n  padding-left: 3rem !important;\n  padding-right: 3rem !important;\n}", "",{"version":3,"sources":["webpack://./src/components/ConfirmationDialog/styles.module.scss"],"names":[],"mappings":"AAAA;EACE,0BAAA;EACA,4BAAA;AACF;;AACA;EACE,6BAAA;EACA,8BAAA;AAEF","sourcesContent":[".title{\n  font-size: 1rem !important;\n  font-weight: bold !important;\n}\n.button{\n  padding-left: 3rem !important;\n  padding-right: 3rem !important;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"title": "styles_title__nmwqs",
	"button": "styles_button__Vknkk"
};
export default ___CSS_LOADER_EXPORT___;
